import { equalizeHeightByOffset }  from './functions.js';

export default function DragScrollModule(element) {

    if ('ontouchstart' in window) {
        return;
    }

    let mouseDown = false;
    let clickEnabled = true;
    let startX, scrollLeft;

    let startDragging = function (e) {
        mouseDown = true;
        startX = e.pageX - element.offsetLeft;
        scrollLeft = element.scrollLeft;

        element.style.cursor = 'grabbing';
        element.style.userSelect = 'none';

    };

    let stopDragging = function (event) {
        mouseDown = false;
        setTimeout(function() {
            clickEnabled = true;
        }, 50);

        element.style.cursor = 'grab';
        element.style.removeProperty('user-select');
    };

    element.addEventListener('mousemove', (e) => {
        e.preventDefault();

        if (!mouseDown) { 
            return; 
        }

        const x = e.pageX - element.offsetLeft;
        const scroll = x - startX;
        element.scrollLeft = scrollLeft - scroll;

        if (Math.abs(scroll) > 30) {
            clickEnabled = false;
        }

        element.dispatchEvent(new Event('scrolled'));

    });

    // Add the event listeners
    element.addEventListener('mousedown',  startDragging, false);
    element.addEventListener('mouseup',    stopDragging, false);
    element.addEventListener('mouseleave', stopDragging, false);

    element.addEventListener('click', function(e) {
        if (!clickEnabled) {
            e.stopPropagation();
            e.preventDefault();
        }
    }, true);


}